import React from 'react';
import styled from 'styled-components';
import 'react-responsive-carousel/lib/styles/carousel.min.css'; // requires a loader
import {Carousel} from 'react-responsive-carousel';
import * as Icon from './Icon';
import FixedRatioImage from './FixedRatioImage';

function ImageCarousel(props) {
  const {
    images,
    ratio = 4 / 6,
    itemExtraCss = '',
    showThumbs = true,
    showIndicators = false,
    autoPlay = false,
    interval = 300,
  } = props;
  return (
    <CarouselWrapper>
      <Carousel
        axis={'horizontal'}
        infiniteLoop
        autoPlay={autoPlay}
        interval={interval}
        showIndicators={showIndicators}
        showStatus={false}
        renderArrowPrev={(onClickHandler, hasPrev, label) => (
          <IconContainer left onClick={onClickHandler}>
            <Icon.KeyboardArrowLeft
              color="#C7C7CC"
              style={{width: 35, height: 35}}
            />
          </IconContainer>
        )}
        renderArrowNext={(onClickHandler, hasNext, label) => (
          <IconContainer right onClick={onClickHandler}>
            <Icon.KeyboardArrowRight
              color="#C7C7CC"
              style={{width: 35, height: 35}}
            />
          </IconContainer>
        )}
        showThumbs={showThumbs}
        thumbWidth={155}
        renderThumbs={(thumbs) =>
          images.map((image, idx) => <Thumbs key={idx} image={image.url} />)
        }>
        {images.map((image, idx) => (
          <FixedRatioImage
            key={idx}
            image={image.url}
            ratio={ratio}
            mode={'cover'}
            extraCss={itemExtraCss + `${image.link ? 'cursor: pointer;' : ''}`}
            onClick={() => {
              image.link && window.location.assign(image.link);
            }}
          />
        ))}
      </Carousel>
    </CarouselWrapper>
  );
}

function Thumbs(props) {
  const {image} = props;
  return <ThumbWrapper image={image} />;
}

const ThumbWrapper = styled.div`
  background-image: ${(props) => `url("${props.image}")`};
  background-size: cover;
  width: 100%;
  height: 100%;
`;

const IconContainer = styled.button`
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  ${(props) => (props.left ? 'left: 15px;' : '')}
  ${(props) => (props.right ? 'right: 15px;' : '')}

  top: 50%;
  z-index: 1;
  transform: translateY(-50%);

  cursor: pointer;
  border: 0px;
  background-color: rgba(255, 255, 255, 0.4);
  border-radius: 50%;
  width: 40px;
  height: 40px;

  :focus {
    outline: none;
  }
`;

const CarouselWrapper = styled.div`
  /* overwrite library style */
  & .carousel {
    & > .thumbs-wrapper {
      margin: 10px 0px 0px;
      overflow-x: auto;

      & > .thumbs {
        padding: 0px;
        & > .thumb {
          height: 100px;
          border: none;
          border-radius: 12px;
          margin-right: 10px;
        }
        & > .thumb.selected,
        & > .thumb.selected:hover {
          border: none;
        }
      }
    }

    .control-dots {
      text-align: right;
      padding-right: 80px;

      & > .dot {
        opacity: 1;
        background: #fff;
        box-shadow: 0 6px 14px 4px rgba(128, 128, 128, 0.32);
      }

      & > .dot.selected {
        background: #b79d7a;
        box-shadow: 0 6px 14px 4px #e0cfb8;
      }
    }
  }
`;

export default ImageCarousel;
